export const APPLY = 'APPLY';
export const BRANDS = 'BRANDS';
export const CLEAR_ALL = 'CLEAR_ALL';
export const FILTER = 'FILTER';
export const FILTERS = 'FILTERS';
export const NO_FILTER_APPLIED = 'NO_FILTER_APPLIED';
export const CATEGORIES = 'CATEGORIES';
export const LOG_IN = 'LOG_IN';
export const NOTIFY_ME = 'NOTIFY_ME';
export const VIEW_SHADES = 'VIEW_SHADES';
export const VIEW_SIZES = 'VIEW_SIZES';
export const SORT_BY = 'SORT_BY';
export const ADD_TO_BAG = 'ADD_TO_BAG';
export const DYNAMIC_COMPLETE_COLLECTION = 'DYNAMIC_COMPLETE_COLLECTION';
export const VIEW_BAG = 'VIEW_BAG';
export const CHANGE = 'CHANGE';
export const READ_LESS = 'READ_LESS';
export const READ_MORE = 'READ_MORE';
export const READ_ALL_REVIEWS = 'READ_ALL_REVIEWS';
export const NO_MORE_PRODUCTS_TO_SHOW = 'NO_MORE_PRODUCTS_TO_SHOW';
export const VIEW_PRODUCTS = 'VIEW_PRODUCTS';
export const RATE = 'RATE';
export const RATE_PRODUCT = 'RATE_PRODUCT';
export const SHARE = 'SHARE';
export const WRITE_A_REVIEW = 'WRITE_A_REVIEW';
export const ADDING = 'ADDING';
export const CHECK = 'CHECK';
export const FETCHING_DELIVERY_DETAILS = 'FETCHING_DELIVERY_DETAILS';
export const PHOTOS_FROM_CUSTOMERS = 'PHOTOS_FROM_CUSTOMERS';
export const REGISTER = 'REGISTER';
export const MOST_USEFUL_REVIEW = 'MOST_USEFUL_REVIEW';
export const ADDED_TO_CART = 'ADDED_TO_CART';
export const SPECIAL_COUPONS = 'SPECIAL_COUPONS';
export const NO_MORE_REVIEWS_TO_SHOW = 'NO_MORE_REVIEWS_TO_SHOW';
export const SEARCH_PRODUCTS = 'SEARCH_PRODUCTS';
export const GET_EXTRA_DISCOUNTS = 'GET_EXTRA_DISCOUNTS';
export const WRITE_NEW = 'WRITE_NEW';
export const GET_SPECIAL_DISCOUNT = 'GET_SPECIAL_DISCOUNT';
export const FEW_LEFT = 'FEW_LEFT';
export const NOTIFY_STOCK = 'NOTIFY_STOCK';
export const YOUR_EMAIL = 'YOUR_EMAIL';
export const HOW_TO_USE = 'HOW_TO_USE';
export const OVERALL_RATING = 'OVERALL_RATING';
export const SHARE_ERROR = 'SHARE_ERROR';
export const SHARE_COPIED = 'SHARE_COPIED';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const REVIEWS_NOT_FOUND = 'REVIEWS_NOT_FOUND';
export const NO_REVIEWS_WRITTEN = 'NO_REVIEWS_WRITTEN';
export const NO_REVIEWS_ON_PRODUCT = 'NO_REVIEWS_ON_PRODUCT';
export const SORT_REVIEWS = 'SORT_REVIEWS';
export const SELECT_SHADE = 'SELECT_SHADE';
export const SELECT_SIZE = 'SELECT_SIZE';
export const SHADE = 'SHADE';
export const SIZE = 'SIZE';
export const SOLD_OUT = 'SOLD_OUT';
export const LOAD_MORE = 'LOAD_MORE';
export const NEED_HELP = 'NEED_HELP';
export const GIFT_CARDS = 'GIFT_CARDS';
export const NYKAA_CSR = 'NYKAA_CSR';
export const RESPONSIBLE_DISCLOSURE = 'RESPONSIBLE_DISCLOSURE';
export const MY_ORDERS = 'MY_ORDERS';
export const MY_WALLET = 'MY_WALLET';
export const NYKAA_PRIVE = 'NYKAA_PRIVE';
export const NYKAA_SUBSCRIPTION = 'NYKAA_SUBSCRIPTION';
export const BEAUTY_PORTFOLIO = 'BEAUTY_PORTFOLIO';
export const LOGOUT = 'LOGOUT';
export const MY_PROFILE = 'MY_PROFILE';
export const CODE_COPIED = 'CODE_COPIED';
export const MY_WISHLIST = 'MY_WISHLIST';
export const AUTHENTICITY = 'AUTHENTICITY';
export const VIDEO_CONSULTATION = 'Nykaa Beauty Advisor';
export const HELP_CENTER = 'HELP_CENTER';
export const SEARCH_PLACEHOLDER = 'SEARCH_PLACEHOLDER';
export const REVIEWS = 'REVIEWS';
export const RATINGS = 'RATINGS';
export const WE_RECOMMEND_YOU = 'WE_RECOMMEND_YOU';
export const LANG_SELECTOR_TOOLTIP_TITLE = 'LANG_SELECTOR_TOOLTIP_TITLE';
export const LANG_SELECTOR_TOOLTIP_MESSAGE = 'LANG_SELECTOR_TOOLTIP_MESSAGE';
export const LANG_SELECTOR_TOOLTIP_CONFIRMATION =
  'LANG_SELECTOR_TOOLTIP_CONFIRMATION';
export const DELIVERY_DETAILS_NOT_FOUND = 'DELIVERY_DETAILS_NOT_FOUND';
export const DYNAMIC_APPLIED = 'DYNAMIC_APPLIED';
export const DYNAMIC_LEFT = 'DYNAMIC_LEFT';
export const DYNAMIC_SIZES = 'DYNAMIC_SIZES';
export const DYNAMIC_SHADES = 'DYNAMIC_SHADES';
export const SHARE_GREETING = 'SHARE_GREETING';
export const DYNAMIC_PRODUCTS = 'DYNAMIC_PRODUCTS';
export const DYNAMIC_RESULTS = 'DYNAMIC_RESULTS';
export const DYNAMIC_SHIPPING = 'DYNAMIC_SHIPPING';
export const DYNAMIC_DELIVERY_EST = 'DYNAMIC_DELIVERY_EST';
export const DYNAMIC_FREE_SHIPPING = 'DYNAMIC_FREE_SHIPPING';
export const DYNAMIC_VERIFIED_RATING = 'DYNAMIC_VERIFIED_RATING';
export const DYNAMIC_DELIVERY_DETAILS = 'DYNAMIC_DELIVERY_DETAILS';
export const DYNAMIC_BASED_ON_REVIEWS_RATINGS =
  'DYNAMIC_BASED_ON_REVIEWS_RATINGS';
export const OFF = 'OFF';
export const FILTER_EN = 'filter';
export const SORT_EN = 'sort';
export const SIMILAR_PRODUCTS = 'SIMILAR_PRODUCTS';
export const VIEW_SIMILAR_PRODUCTS = 'VIEW_SIMILAR_PRODUCTS';
export const ADD_TO_WISHLIST = 'ADD_TO_WISHLIST';
export const ADDED_TO_WISHLIST = 'ADDED_TO_WISHLIST';
export const VIEW_ALL_PRODUCTS = 'VIEW_ALL_PRODUCTS';
export const PLP = 'PLP';
export const RECO_PRODUCTS = 'RECO_PRODUCTS';
export const PROFILE_CLICK = 'profile_click';
export const DISCARD_CHANGES = 'Discard Changes ?';
export const DISCARD_CHANGES_SUBTITLE =
  'You modified some filters. Would you like to apply the changes or discard them?';
export const DISCARD = 'Discard';
export const Apply = 'Apply';
export const ONLY_TAGS = 'ONLY_TAGS';
export const TAGS_AND_RATING = 'TAGS_AND_RATING';
export const ONLY_RATINGS = 'ONLY_RATINGS';
export const SIMILAR_PRODUCTS_TEXT = 'Similar Products';
export const SIMILAR_PRODUCTS_NBSKU = 'Similar products';
export const SUSTAINABILITY = 'Sustainability';
export const buyNowCtaText = 'Buy Now';
